import React, { useState } from "react";
import logoSimple from "../images/ispace_plus_logo_600dpi.png";

const Login = ({onLogin}) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const containerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // Full viewport height
    };

    const greenTextStyle={
        color: "#035942"
    }

    const formStyle = {
        width: "100%",
        maxWidth: "400px",
        padding: "15px",
        margin: "auto",
    };

    const logoContainerStyle = {
        display: "flex",
        justifyContent: "center",
        margin: "20px 0",
    };

    const logoSimpleStyle = {
        width: "130px",
    };

    const handleLogin = async () => {
        try {
            const response = await fetch(`./auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include", // This ensures the cookie is sent
                body: JSON.stringify({ username, password })
            });

            if (response.ok) {
                alert("Login erfolgreich!");
                onLogin(); // Trigger the authentication check
            } else {
                alert("Login fehlgeschlagen!");
            }
        } catch (error) {
            alert("Login fehlgeschlagen!");
        }
    };

    return (
        <div style={containerStyle}>
        <div className="form-signin" style={formStyle}>
                <h2 className="h3 mb-3 fw-normal" style={greenTextStyle}>Anmelden</h2>
                <form onSubmit={async (e)=>{
                    e.preventDefault(); // Prevent the form from reloading the page before the login request finishes
                    await handleLogin();
                }}>
                <div className="mb-3">
                    <label className="form-label">Benutzername</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Benutzername"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        required
                        autoComplete="username"
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Passwort</label>
                    <div style={{position:"relative"}}>
                        <input
                            type={showPassword?"text":"password"}
                            className="form-control"
                            placeholder="Passwort"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                            style={{ paddingRight: "90px" }}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(prev => !prev)}
                            aria-label={showPassword ? "Passwort ausblenden" : "Passwort anzeigen"}
                            style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                padding: 0,
                                color: "#666666"
                            }}
                        >{showPassword ? "Ausblenden" : "Anzeigen"}</button>
                    </div>
            </div>
            <button type="submit" className="btn btn-dark w-100 py-2">Anmelden</button>
            <div className="m-2 small"><i>Probleme beim Anmelden?{" "} <a href="mailto: contact@ispaceplus.at" style={{ color: "#666666", textDecoration: "underline"}}>contact@ispaceplus.at</a></i>
            </div>
            <div style={logoContainerStyle}>
                        <img src={logoSimple} alt="logo-ispace-plus" style={logoSimpleStyle} />
            </div>
       </form>
    </div>
    </div>
        
    );
};

export default Login;